// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled, {css} from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:ClipboardCopy'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';

// Style for Main Components (things you may export)
const StyledClipboardCopy = styled(CopyToClipboard)`
	display: inline-flex;
	align-items: center;

i,
.copiedNotification {
	margin-left: 0.5rem;
	opacity: 0;
	transition: opacity 0.25s ease-in;
}

i {
	font-size: 1.25rem;
  cursor: pointer;
  opacity: ${props => props.canCopy ? 1 : 0};
}
i:hover {
  color: ${({theme}) => theme.ThemeColors.TEXT.hex};
  font-weight: bold;
}

.copiedNotification {
	font-weight: 300;
	font-size: 0.9rem;
}

.copiedNotification.wasCopied {
	opacity: 1;
}
`;

const initialValues = {
  isCopied: false,
  fontSize: '1rem',
  canCopy: false,
};

// Bindings
type ClipboardCopyProps = {
  theme?: ThemeType,
  isCopied: boolean,
  fontSize?: string,
  canCopy: boolean,
  textToCopy: string | Function,
};

class ClipboardCopy extends Component {
  props: ClipboardCopyProps;
  static defaultProps = initialValues;
  state = {
    wasCopied: false,
  };

//  ----Template----

  render() {
    const {wasCopied} = this.state;
    const {canCopy, textToCopy} = this.props;
    return (
        <StyledClipboardCopy
            className={'clipboard'}
            text={textToCopy}
            canCopy={canCopy}
            onCopy={this.clipboardCopyWithTimeout}>
            <div onClick={(e) => e.stopPropagation()}>
              <Icon icon={IconLookup.CLIPBOARD_CHECK} />
              <span className={`copiedNotification ${wasCopied ? 'wasCopied' : ''}`}>Copied!</span>
            </div>
        </StyledClipboardCopy>
    );
  }

// ----Lifecycle Hooks----

// ----Methods----

  clipboardCopyWithTimeout = (option: Object) => {
    const ourState = this;
    this.setState({
      wasCopied: true,
    });
    setTimeout(() => {
      ourState.setState({
        wasCopied: false,
      });
    }, 2000);
  };
}

// Logic & Helper Components
const options = [

];

export {ClipboardCopy};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/ClipboardCopy.js